export default __webpack_public_path__ + "515f9724f8851d618888f5ff4a81d83e.svg";